import FullLayout from '@/layouts/full/FullLayout.vue';
import type { RouteRecordRaw } from 'vue-router';

// ────────────────────────────────────────────────────────────
// Financeiro > Relatórios > Extratos (FINR470 live)
// As 3 rotas são REAIS de propósito: o syncFrontendRoutes (login do
// Admin Master) cadastra cada path na tabela `routes`, e o backend
// verifica a permissão por empresa nos paths /via e /sim.
// A mesma view atende as 3; meta.tenant pré-seta o switcher.
// ────────────────────────────────────────────────────────────

export const financeiroRelatoriosRoutes: RouteRecordRaw[] = [
  {
    path: '/financeiro/relatorios/extratos',
    component: FullLayout,
    meta: { requiresAuth: true, title: 'Financeiro — Extratos Bancários' },
    children: [
      {
        path: '',
        name: 'ExtratosBancarios',
        component: () => import('@/views/Financeiro/Extratos/ExtratoBancario.vue'),
        meta: {
          requiresAuth: true,
          title: 'Extratos Bancários',
          breadcrumb: 'Financeiro / Relatórios / Extratos',
        },
      },
      {
        path: 'via',
        name: 'ExtratosBancariosVia',
        component: () => import('@/views/Financeiro/Extratos/ExtratoBancario.vue'),
        meta: {
          requiresAuth: true,
          tenant: 'via',
          title: 'Extratos — Via Education',
          breadcrumb: 'Financeiro / Relatórios / Extratos',
        },
      },
      {
        path: 'sim',
        name: 'ExtratosBancariosSim',
        component: () => import('@/views/Financeiro/Extratos/ExtratoBancario.vue'),
        meta: {
          requiresAuth: true,
          tenant: 'sim',
          title: 'Extratos — Siminova',
          breadcrumb: 'Financeiro / Relatórios / Extratos',
        },
      },
    ],
  },

  // ────────────────────────────────────────────────────────────
  // Financeiro > Relatórios > Posição de Clientes (FINR340 live)
  // As 3 rotas são reais p/ o syncFrontendRoutes cadastrar cada path
  // (a geral herda o maior nível de /via·/sim; backend valida por empresa).
  // ────────────────────────────────────────────────────────────
  {
    path: '/financeiro/relatorios/posicao-clientes',
    component: FullLayout,
    meta: { requiresAuth: true, title: 'Financeiro — Posição de Clientes' },
    children: [
      {
        path: '',
        name: 'PosicaoClientes',
        component: () => import('@/views/Financeiro/PosicaoFinanceira/PosicaoFinanceira.vue'),
        meta: { requiresAuth: true, tipo: 'clientes', title: 'Posição de Clientes', breadcrumb: 'Financeiro / Relatórios / Posição de Clientes' },
      },
      {
        path: 'via',
        name: 'PosicaoClientesVia',
        component: () => import('@/views/Financeiro/PosicaoFinanceira/PosicaoFinanceira.vue'),
        meta: { requiresAuth: true, tipo: 'clientes', tenant: 'via', title: 'Posição de Clientes — Via Education', breadcrumb: 'Financeiro / Relatórios / Posição de Clientes' },
      },
      {
        path: 'sim',
        name: 'PosicaoClientesSim',
        component: () => import('@/views/Financeiro/PosicaoFinanceira/PosicaoFinanceira.vue'),
        meta: { requiresAuth: true, tipo: 'clientes', tenant: 'sim', title: 'Posição de Clientes — Siminova', breadcrumb: 'Financeiro / Relatórios / Posição de Clientes' },
      },
    ],
  },

  // ── Financeiro > Relatórios > Posição de Fornecedores (FINR350 live) ──
  {
    path: '/financeiro/relatorios/posicao-fornecedores',
    component: FullLayout,
    meta: { requiresAuth: true, title: 'Financeiro — Posição de Fornecedores' },
    children: [
      {
        path: '',
        name: 'PosicaoFornecedores',
        component: () => import('@/views/Financeiro/PosicaoFinanceira/PosicaoFinanceira.vue'),
        meta: { requiresAuth: true, tipo: 'fornecedores', title: 'Posição de Fornecedores', breadcrumb: 'Financeiro / Relatórios / Posição de Fornecedores' },
      },
      {
        path: 'via',
        name: 'PosicaoFornecedoresVia',
        component: () => import('@/views/Financeiro/PosicaoFinanceira/PosicaoFinanceira.vue'),
        meta: { requiresAuth: true, tipo: 'fornecedores', tenant: 'via', title: 'Posição de Fornecedores — Via Education', breadcrumb: 'Financeiro / Relatórios / Posição de Fornecedores' },
      },
      {
        path: 'sim',
        name: 'PosicaoFornecedoresSim',
        component: () => import('@/views/Financeiro/PosicaoFinanceira/PosicaoFinanceira.vue'),
        meta: { requiresAuth: true, tipo: 'fornecedores', tenant: 'sim', title: 'Posição de Fornecedores — Siminova', breadcrumb: 'Financeiro / Relatórios / Posição de Fornecedores' },
      },
    ],
  },
  // ────────────────────────────────────────────────────────────
  // Financeiro > Documentos Fiscais (TSS live) — item DIRETO de Financeiro no
  // menu; o `/relatorios/` do path é herança do agrupamento das rotas e não
  // aparece para o usuário (breadcrumb e cabeçalho dizem só 'Financeiro').
  // As 3 rotas são REAIS p/ o syncFrontendRoutes cadastrar cada path
  // (a geral herda o maior nível de /via·/sim; backend valida por empresa).
  // ────────────────────────────────────────────────────────────
  {
    path: '/financeiro/relatorios/fiscal-tss',
    component: FullLayout,
    meta: { requiresAuth: true, title: 'Financeiro — Documentos Fiscais' },
    children: [
      {
        path: '',
        name: 'DocumentosFiscaisTss',
        component: () => import('@/views/Financeiro/FiscalTss/FiscalTss.vue'),
        meta: { requiresAuth: true, title: 'Documentos Fiscais (TSS)', breadcrumb: 'Financeiro / Documentos Fiscais' },
      },
      {
        path: 'via',
        name: 'DocumentosFiscaisTssVia',
        component: () => import('@/views/Financeiro/FiscalTss/FiscalTss.vue'),
        meta: { requiresAuth: true, tenant: 'via', title: 'Documentos Fiscais — Via Education', breadcrumb: 'Financeiro / Documentos Fiscais' },
      },
      {
        path: 'sim',
        name: 'DocumentosFiscaisTssSim',
        component: () => import('@/views/Financeiro/FiscalTss/FiscalTss.vue'),
        meta: { requiresAuth: true, tenant: 'sim', title: 'Documentos Fiscais — Siminova', breadcrumb: 'Financeiro / Documentos Fiscais' },
      },
    ],
  },

  // ────────────────────────────────────────────────────────────
  // Financeiro > Relatórios > Contas CC (por centro de custo, live)
  // Permissão ÚNICA (sem escopo /via /sim): quem tem a rota consulta
  // VIA, SIM e AMBAS. Seed da rota via migration 180 (fail-secure).
  // ────────────────────────────────────────────────────────────
  {
    path: '/financeiro/centro-de-custo',
    component: FullLayout,
    meta: { requiresAuth: true, title: 'Contas CC' },
    children: [
      {
        path: '',
        name: 'ContasCC',
        component: () => import('@/views/Financeiro/ContasCC/ContasCC.vue'),
        meta: {
          requiresAuth: true,
          title: 'Contas CC',
          breadcrumb: 'Financeiro / Relatórios / Contas CC',
        },
      },
    ],
  },
];

export default financeiroRelatoriosRoutes;
